import React from "react";
import { Box, Button, Typography } from "@mui/material";
import FilterListIcon from '@mui/icons-material/FilterAltOutlined';
import RefreshIcon from '@mui/icons-material/Refresh';

interface CoverageToolbarProps {
    filtersCount: number;
    toggleFilterDrawer: () => void;
    resetFilters: () => void;
}

const CoverageToolbar: React.FC<CoverageToolbarProps> = ({ 
    filtersCount, 
    toggleFilterDrawer, 
    resetFilters
}) => {
    return (
        <Box sx={{ mt: 2, mb: 2, display: 'flex', justifyContent: 'space-between' }}>
            <Box display="flex">
                <Button
                    variant={filtersCount === 0 ? "outlined" : "contained"}
                    color="primary"
                    startIcon={<FilterListIcon fontSize="small" />}
                    onClick={toggleFilterDrawer}
                    aria-label="open drawer"
                >
                    <Typography variant="subtitle2">Filters [{filtersCount}]</Typography>
                </Button>
                <Button
                    style={{ marginLeft: "10px", marginRight: "10px" }}
                    variant="outlined"
                    color="primary"
                    startIcon={<RefreshIcon fontSize="small" />}
                    onClick={resetFilters}
                    aria-label="Refresh"
                >
                    <Typography variant="subtitle2">Reset</Typography>
                </Button>
            </Box>
        </Box>
    );
};

export default CoverageToolbar;
